import React from "react";
import clsx from "clsx";
import { useStore } from "effector-react";
import { Box, Collapse, IconButton, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Close, FastForward, FastRewind, Pause, PlayArrow, Shuffle, } from "@material-ui/icons";
import { If } from "frontend/src/ui/if";
import { PlayerContainer } from "./player-container";
import { PlayerTimeRange } from "./timerange";
import { Volume } from "frontend/src/features/change-audio-volume";
import { $playerCurrentTrack, $playerHasCurrentTrack, $playerHasNextTrack, $playerHasPreviousTrack, $playerShuffleEnabled, playerShuffleToggled, } from "../../../domain/player-track-queue";
import { tryPlayNextTrackInQueue } from "../../play-track-from-queue";
import { $activeTimetableInterruptionTrack } from "frontend/src/features/play-timetable-interruptions";
import { $isAudioPlaying } from "../../../domain/audio";
import { pause, resume } from "../../control-audio";
import { $activeWebSchedule, stopWebScheduleAttempted, } from "frontend/src/features/play-web-schedule";
var useStyles = makeStyles({
    container: {
        width: "100%",
        minWidth: 0,
        "& .MuiCollapse-root, & .MuiCollapse-container, & .MuiCollapse-wrapper, & .MuiCollapse-wrapperInner": {
            width: "100%",
            minWidth: 0,
        },
    },
    box: {
        transition: "height 0.2s",
    },
    activeButton: {
        color: "#4fc3f7",
    },
});
var Bar = function (_a) {
    var track = _a.track, hasCurrentTrack = _a.hasCurrentTrack, isPlaying = _a.isPlaying, playPause = _a.playPause, hasNextTrack = _a.hasNextTrack, playNextTrack = _a.playNextTrack, shuffleEnabled = _a.shuffleEnabled, toggleShuffle = _a.toggleShuffle;
    var classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { variant: "body1", noWrap: true }, track === null || track === void 0 ? void 0 : track.title),
        React.createElement(Box, { display: "flex", ml: "auto" },
            React.createElement(Box, null,
                React.createElement(IconButton, { onClick: playPause, disabled: !hasCurrentTrack }, isPlaying ? (React.createElement(Pause, { fontSize: "large" })) : (React.createElement(PlayArrow, { fontSize: "large" })))),
            React.createElement(IconButton, { disabled: !hasCurrentTrack, onClick: toggleShuffle, className: shuffleEnabled ? classes.activeButton : undefined },
                React.createElement(Shuffle, { fontSize: "large" })),
            React.createElement(IconButton, { disabled: !hasCurrentTrack, onClick: toggleShuffle, className: shuffleEnabled ? classes.activeButton : undefined },
                React.createElement(Shuffle, { fontSize: "large" })),
            React.createElement(IconButton, { disabled: !hasNextTrack, onClick: playNextTrack },
                React.createElement(FastForward, { fontSize: "large" })))));
};
var FullBar = function (_a) {
    var track = _a.track, hasCurrentTrack = _a.hasCurrentTrack, isPlaying = _a.isPlaying, playPause = _a.playPause, hasNextTrack = _a.hasNextTrack, playNextTrack = _a.playNextTrack, shuffleEnabled = _a.shuffleEnabled, toggleShuffle = _a.toggleShuffle;
    var classes = useStyles();
    var hasPreviousTrack = useStore($playerHasPreviousTrack);
    var playPreviousTrack = function (evt) {
        evt.stopPropagation();
        tryPlayNextTrackInQueue();
    };
    return (React.createElement(Box, { mt: "auto" },
        React.createElement(Box, { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" },
            React.createElement(Typography, { variant: "h5" }, track === null || track === void 0 ? void 0 : track.title),
            React.createElement(Typography, null, track && track.type === "public" && track.artist)),
        React.createElement(Box, null,
            React.createElement(PlayerTimeRange, { track: track })),
        React.createElement(Box, { display: "flex", justifyContent: "center" },
            React.createElement(IconButton, { disabled: !hasPreviousTrack, onClick: playPreviousTrack },
                React.createElement(FastRewind, { fontSize: "large" })),
            React.createElement(Box, null,
                React.createElement(IconButton, { disabled: !hasCurrentTrack, onClick: playPause }, isPlaying ? (React.createElement(Pause, { fontSize: "large" })) : (React.createElement(PlayArrow, { fontSize: "large" })))),
            React.createElement(IconButton, { disabled: !hasNextTrack, onClick: playNextTrack },
                React.createElement(FastForward, { fontSize: "large" }))),
        React.createElement(Box, { mb: 2 },
            React.createElement(Volume, null))));
};
export var MobilePlayerBar = function (_a) {
    var _b;
    var containerClassName = _a.containerClassName, _c = _a.fullWidth, fullWidth = _c === void 0 ? true : _c;
    var classes = useStyles();
    var track = useStore($playerCurrentTrack);
    var activeInterruption = useStore($activeTimetableInterruptionTrack);
    var visibleTrack = (_b = activeInterruption === null || activeInterruption === void 0 ? void 0 : activeInterruption.track) !== null && _b !== void 0 ? _b : track;
    var isPlaying = useStore($isAudioPlaying);
    var activeWebSchedule = useStore($activeWebSchedule);
    var hasCurrentTrack = useStore($playerHasCurrentTrack);
    var hasNextTrack = useStore($playerHasNextTrack);
    var shuffleEnabled = useStore($playerShuffleEnabled);
    var _d = React.useState(false), showFullMenu = _d[0], setShowFullMenu = _d[1];
    var playPause = function (evt) {
        evt.stopPropagation();
        if (isPlaying && activeWebSchedule) {
            stopWebScheduleAttempted();
            return;
        }
        isPlaying ? pause() : resume();
    };
    var playNextTrack = function (evt) {
        evt.stopPropagation();
        tryPlayNextTrackInQueue();
    };
    var toggleShuffle = function (evt) {
        evt.stopPropagation();
        playerShuffleToggled();
    };
    return (React.createElement(PlayerContainer, { onClick: function () {
            if (!showFullMenu) {
                setShowFullMenu(true);
            }
        }, className: clsx(classes.container, containerClassName), fullWidth: fullWidth },
        React.createElement(Collapse, { in: showFullMenu, collapsedHeight: 60 },
            React.createElement(Box, { display: "flex", flexDirection: "column", width: "100%", height: 300 },
                React.createElement(If, { condition: showFullMenu },
                    React.createElement(Box, { display: "flex", justifyContent: "flex-end" },
                        React.createElement(IconButton, { onClick: function () { return setShowFullMenu(false); } },
                            React.createElement(Close, null)))),
                React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" },
                    React.createElement(If, { condition: !showFullMenu },
                        React.createElement(Bar, { track: visibleTrack, hasCurrentTrack: hasCurrentTrack, hasNextTrack: hasNextTrack, playPause: playPause, isPlaying: isPlaying, playNextTrack: playNextTrack, shuffleEnabled: shuffleEnabled, toggleShuffle: toggleShuffle }))),
                React.createElement(If, { condition: showFullMenu },
                    React.createElement(FullBar, { track: visibleTrack, hasCurrentTrack: hasCurrentTrack, hasNextTrack: hasNextTrack, playPause: playPause, isPlaying: isPlaying, playNextTrack: playNextTrack, shuffleEnabled: shuffleEnabled, toggleShuffle: toggleShuffle }))))));
};
